import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper, { cleanCollisions, continuousExtentParts } from '../chart_helpers/AxisHelper'
import SizeHelper from '../chart_helpers/SizeHelper'
import { categoricalExtent, continuousExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import { tweenDentedRect } from '../utils/pathUtils'
import { select as d3_select } from 'd3-selection'
import { interpolateRgb as d3_interpolateRgb } from 'd3-interpolate'
import TrendLinesHelper from '../chart_helpers/TrendLinesHelper'
import { ACCESSIBILITY_OPTIONS_KEYS } from '../utils/accessibilityUtils'

const MAX_BAR_WIDTH = 40
export default class WaterfallChartChart extends BaseChart {
  constructor(...args) {
    super(...args)
    this.zeroBased = true
  }
  static defaultConfig = {
    /**
     * {-EN-} If a value is provided, it adds at total column at the end of the chart. The value of the attribute is the name of the total column.
     * {-ES-} Si se proporciona un valor, se suma a la columna total al final del gráfico. El valor del atributo es el nombre de la columna total.
     */
    computedTotal: {
      type: String,
      default: 'Total',
      exposed: true,
    },
    ItemsHelper: {
      colorKey: 'colorType',
    },
    /**
     * {-EN-} Orientation of the bars. When setting `horizontal: true` the x and y axes will be swapped.
     * {-ES-} Orientación de las barras. Al configurar `horizontal: true`, los ejes x e y se intercambiarán.
     */
    horizontal: {
      type: Boolean,
      default: false,
      exposed: true,
    },

    dataSorting: {
      type: [String],
      default: 'none',
      options: ['none'],
      exposed: false,
    },
    /**
     * {-EN-} Show the value on top of each bar.
     * {-ES-} Muestra el valor encima de cada barra.
     */
    showDatumValues: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    datumValuesPosition: {
      type: String,
      default: 'top',
      options: ['top', 'center', 'bottom', 'insideBeginning', 'insideEnd'],
      exposed: true,
    },
    /**
     * {-EN-} Minimum height of each bar (in pixels).
     * {-ES-} Altura mínima de cada barra (en píxeles).
     */
    minBarHeight: {
      type: [Number],
      default: 0,
      exposed: true,
    },
    hasColorPatterns: {
      type: Boolean,
      default: true,
      exposed: false,
    },
    AxisHelper: {
      zoom: {
        nonEditable: true,
      },
      scroll: {
        default: false,
        exposed: true,
      },
      showScrollbar: {
        default: true,
        exposed: true,
      },
      x: {
        scale: {
          value: 'band',
          exposed: false,
        },
        getExtent: function (data) {
          return categoricalExtent(data)
        },
      },
      y: {
        side: 'right',
        getExtent: function (data) {
          let extent, extentParts
          extentParts = data.map(d => ({ value: [d.y0, d.y1] }))
          extent = continuousExtent(data.map(d => [d.y0, d.y1]).flat(), d => d)
          if (this.config.AxisHelper.y.showTickValues && this.config.AxisHelper.y.unit) {
            extent = cleanCollisions(this.axes.y, extent, extentParts)
          }
          return extent
        },
      },
    },
    TooltipBehavior: {
      getItemOffset: function ($el) {
        // se podria intentar algo para que salga "por ariiba o por abajo" en funcion del +/-
        let original = $el.children[0].getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top, //- 5,
        }
      },
      getHtml: function (d) {
        return `
          <div class="tip-value important">${this.formatTooltipValue(d.value, 'y')}</div>
          <div class="tip-id">
            <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
              d
            )}; margin-right: 3px"></span>
            ${d.id}
          </div>
            `
      },
    },
    TrendLinesHelper: {
      /*
      linesDict: {
        value: {
          line_1: {
            serie: 'all',
            type: 'min',
            label: 'Trend line 1',
            color: '#CC0000',
            polynomialOrder: '3',
          },
        },
      },
      */
      /*
      getItemOffset: function (d) {
        const getPositions = (x, y) => {
          if (this.config.horizontal) return { x: y, y: x }
          return { x, y }
        }

        let getOffset = v => {
          if (this.axes.y.func.scale().domain()[0] === 0)
            return Math.min(v, this.axes.y.func.scale()(offsetValue))
          else return this.axes.y.func.scale()(offsetValue)
        }
        let offsetValue
        if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
          offsetValue = 0
        else offsetValue = this.axes.y.func.scale().domain()[0]

        let barPercent = 0.7
        let barWidth = Math.min(MAX_BAR_WIDTH, this.axes.x.scale.bandwidth() * barPercent)
        let barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2
        let subBarWidth

        if (this.config.mode === 'stacked') {
          let stackPadding = 2
          let barPos = this.axes.y.func.scale()(this.config.horizontal ? d.y0 : d.y1)
          return getPositions(
            this.axes.x.func.scale()(d.id) + barMargin,
            this.axes.y.func.scale()(d.value)
          )
        } else if (this.config.mode === 'grouped') {
          barWidth = this.axes.x.scale.bandwidth() * barPercent
          barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2
          let subScale = d3_scaleBand()
            .domain(this.data.map(d => d.id))
            .range([barMargin, barMargin + barWidth]) //.range([w/2-w/6,w/2+w/3-w/6])
          let subBarPercent = 0.7
          // let subBarWidth = subScale.bandwidth()*subBarPercent
          // let subBarMargin = subScale.bandwidth()*(1-subBarPercent)/2
          subBarWidth = Math.min(MAX_BAR_WIDTH, subScale.bandwidth() * subBarPercent)
          let subBarMargin = (subScale.bandwidth() - subBarWidth) / 2
          let barPos = getOffset(this.axes.y.func.scale()(d.safeValue))
          return getPositions(
            this.axes.x.func.scale()(d.id) + barWidth / 2,
            this.axes.y.func.scale()(d.value) //barPos
          )
        } else {
          return getPositions(
            this.axes.x.func.scale()(d.id) + barMargin + barWidth / 2,
            this.axes.y.func.scale()(d.value)
          )
        }
      },
      */
      getCategoriesData: function () {
        if (this.config.mode === 'grouped') {
          return this.data
            .reduce((accumulator, current) => {
              current.value.forEach(value => {
                accumulator.push(value)
              })
              return accumulator
            }, [])
            .flat()
        }
        return this.data.map(item => ({ parentId: item.id, ...item }))
      },
    },
  }
  static helpers = [
    RootHelper,
    ItemsHelper,
    SelectableHelper,
    SizeHelper,
    AxisHelper,
    TrendLinesHelper,
  ]
  checkConsistency() {
    return true
  }
  draw() {
    let self = this
    let longDir, getTranslate, getOffset, getShort //,shortDir

    let barWidth, subBarWidth
    if (this.config.horizontal) {
      longDir = 'height'
      // shortDir = 'width'
      getTranslate = (long, short) => {
        return `translate(${short},${long})`
      }

      let offsetValue
      if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
        offsetValue = 0
      else offsetValue = this.axes.y.func.scale().domain()[0]

      // getOffset = v => Math.min(v, this.axes.y.func.scale()(offsetValue))
      getOffset = v => {
        if (this.axes.y.func.scale().domain()[0] === 0)
          return Math.min(v, this.axes.y.func.scale()(offsetValue))
        else return this.axes.y.func.scale()(offsetValue)
      }
      // getShort = v => Math.abs(this.axes.y.func.scale()(offsetValue) - v)
      getShort = v => {
        let val = this.axes.y.func.scale()(offsetValue) - v
        return Math.abs(val)
      }
    } else {
      longDir = 'width'
      // shortDir = 'height'
      getTranslate = (long, short) => {
        return `translate(${long},${short})`
      }

      let offsetValue
      if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
        offsetValue = 0
      else offsetValue = this.axes.y.func.scale().domain()[0]

      getOffset = v => Math.min(v, this.axes.y.func.scale()(offsetValue))
      // getShort = v => Math.abs(this.axes.y.func.scale()(offsetValue) - v)
      getShort = v => {
        let val = this.axes.y.func.scale()(offsetValue) - v
        return Math.abs(val)
      }
    }

    let barPercent = 0.7
    barWidth = Math.min(MAX_BAR_WIDTH, this.axes.x.scale.bandwidth() * barPercent)
    let barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2

    function fillTween(d) {
      const fill = self.fill(d)
      if (fill?.includes('url'))
        return function (t) {
          return fill
        }
      else {
        const currentFill = d3_select(this).attr('fill')
        var i = d3_interpolateRgb(currentFill, fill)
        return function (t) {
          return i(t)
        }
      }
    }

    let drawItem

    let stackPadding = 2
    drawItem = (sel, status) => {
      sel.attr('transform', d => {
        let barPos
        if (status === 'enter' || status === 'exit') barPos = this.axes.y.func.scale()(0)
        else {
          //Condition in order to prevent overlapping when setting manual domain
          if (
            this.config.horizontal &&
            !d.isFirstLayer &&
            d.y0 < this.axes.y.func.scale().domain()[0]
          ) {
            barPos = 0
          } else {
            barPos = this.axes.y.func.scale()(this.config.horizontal ? d.y0 : d.y1)
          }
        }
        return getTranslate(
          this.axes.x.func.scale()(d.id) + barMargin,
          barPos +
            (this.config.horizontal
              ? d.isFirstLayer && this.axes.y.func.scale().domain()[0] > 0
                ? Math.abs(this.axes.y.func.scale()(0))
                : 0
              : stackPadding / 2)
        )
      })

      sel.each(function (d) {
        let barLength
        if (status === 'enter' || status === 'exit') barLength = 0
        else {
          let [y0, y1] = [d.y0, d.y1]
          //Condition block in order to prevent overlapping when setting manual domain
          //Check if is negative domain
          if (self.axes.y.func.scale().domain()[0] < 0)
            barLength = getShort(self.axes.y.func.scale()(d.safeValue)) - stackPadding
          //Check if domain is higher than the data and if is not first layer
          else if (y0 < self.axes.y.func.scale().domain()[0]) {
            barLength = getShort(self.axes.y.func.scale()(y1)) - stackPadding
          } else {
            self.config.horizontal
              ? (barLength =
                  getShort(self.axes.y.func.scale()(y1) - self.axes.y.func.scale()(y0)) -
                  stackPadding)
              : (barLength =
                  getShort(
                    self.axes.y.func.scale()(y1) -
                      self.axes.y.func.scale()(y0) +
                      self.axes.y.func.scale().range()[0]
                  ) - stackPadding)
          }
        }
        barLength = Math.max(barLength, 0) //y le faltaba esto para cuando el "safeValue" da 0!!!

        this._barLength = barLength
      })

      sel
        .select('line')
        .style('display', d => (d.isLast ? 'none' : 'inherit'))
        .attr('stroke', this.config.skin === 'light' ? '#e3e3e3' : '#434343')
        // .attr('stroke-dasharray','5')
        .attr('stroke-width', 'hairline')
      if (this.config.horizontal) {
        sel
          .select('line')
          .attr('y1', d => barWidth / 2)
          .attr('y2', d => this.axes.x.scale.step() + barWidth / 2)
          .attr('x1', function (d) {
            return d.value < 0 ? -0.5 : this.parentElement._barLength + 0.5
          })
          .attr('x2', function (d) {
            return d.value < 0 ? -0.5 : this.parentElement._barLength + 0.5
          })
      } else {
        sel
          .select('line')
          .attr('x1', d => barWidth / 2)
          .attr('x2', d => this.axes.x.scale.step() + barWidth / 2)
          .attr('y1', function (d) {
            return d.value > 0 ? -0.5 : this.parentElement._barLength + 0.5
          })
          .attr('y2', function (d) {
            return d.value > 0 ? -0.5 : this.parentElement._barLength + 0.5
          })
      }

      if (sel.select('path').attrTween) {
        sel.select('path').attrTween('d', function (d) {
          // let barLength
          // if (status === 'enter' || status === 'exit') barLength = 0
          // else {
          //   let [y0, y1] = [d.y0, d.y1]
          //   //Condition block in order to prevent overlapping when setting manual domain
          //   //Check if is negative domain
          //   if (self.axes.y.func.scale().domain()[0] < 0)
          //     barLength =
          //       getShort(self.axes.y.func.scale()(d.safeValue)) -
          //       stackPadding
          //   //Check if domain is higher than the data and if is not first layer
          //   else if (y0 < self.axes.y.func.scale().domain()[0]) {
          //     barLength = getShort(self.axes.y.func.scale()(y1)) - stackPadding
          //   } else {
          //     self.config.horizontal
          //       ? (barLength =
          //           getShort(
          //             self.axes.y.func.scale()(y1) -
          //               self.axes.y.func.scale()(y0)

          //           ) - stackPadding)
          //       : (barLength =
          //           getShort(
          //             self.axes.y.func.scale()(y1) -
          //               self.axes.y.func.scale()(y0) +
          //               self.axes.y.func.scale().range()[0]

          //           ) - stackPadding)
          //   }
          // }
          // barLength = Math.max(barLength, 0) //y le faltaba esto para cuando el "safeValue" da 0!!!

          return tweenDentedRect.call(this, d, {
            barLength: this.parentElement._barLength,
            barWidth,
            longDir,
            scale: self.axes.y.func.scale(),
          })
        })
        sel.select('path').attrTween('fill', function (d) {
          return fillTween.bind(this)({ ...d, id: d.type })
        })
      }
    }

    this.itemsEnter.append('path')
    this.itemsEnter.append('line')
    // HAy que pintar lo "viejos" primero para assegurar que se mantiene el orden de colores...
    this.itemsTrans.call(drawItem).style('opacity', 1)
    this.itemsEnter.call(drawItem, 'enter')
    this.itemsEnterTrans.call(drawItem).style('opacity', 1)
    this.itemsExitTrans.style('opacity', 0)
    if (this.parentItemsExitTrans) this.parentItemsExitTrans.style('opacity', 0)

    let datumValues = this.itemsEnter
      .merge(this.items)
      .selectAll('.datum-value')
      .data(d => {
        if (this.config.showDatumValues) {
          if (this.config.mode === 'stacked') {
            if (this.config.datumValuesPosition === 'center') {
              return [{ value: d.y1, safeValue: d.y1 - d.y0 }]
            } else if (this.config.datumValuesPosition === 'bottom') {
              if (d.isFirstLayer) return [{ ...d, value: d.barMax }]
              return []
            } else if (this.config.datumValuesPosition === 'top') {
              if (d.isLastLayer) return [{ ...d, value: d.barMax }]
              return []
            }
          } else {
            return [d]
          }
        } else {
          return []
        }
      })
    datumValues.exit().transition().style('opacity', 0).remove()
    datumValues = datumValues.merge(
      datumValues
        .enter()
        .append('text')
        .attr('class', 'datum-value')
        .style('opacity', 0)
        .style('font-weight', 'bold')
        .attr('fill', 'currentColor')
    )
    datumValues
      .text(d => {
        return this.valueWithUnit(d.value, 'y')
      })
      .attr(
        'font-size',
        this._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
          ? '18px'
          : '14px'
      )
      // .text(d => this.valueWithUnit(d.value, 'y'))
      .transition()
      .style('opacity', 1)

    const getDatumValuesXPosition = d => {
      if (this.config.horizontal) {
        switch (this.config.datumValuesPosition) {
          case 'top':
            return getShort(this.axes.y.func.scale()(d.safeValue)) + 8
          case 'center':
            return getShort(this.axes.y.func.scale()(d.safeValue)) / 2
          case 'bottom':
            return -8
          case 'insideBeginning':
            return 8
          case 'insideEnd':
            return getShort(this.axes.y.func.scale()(d.safeValue)) - 8
        }
      } else {
        return this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2
      }
    }
    const getDatumValuesYPosition = d => {
      if (this.config.horizontal) {
        return this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2
      } else {
        switch (this.config.datumValuesPosition) {
          case 'top':
            return -8
          case 'insideEnd':
            return 12
          case 'center':
            return getShort(this.axes.y.func.scale()(d.safeValue)) / 2
          case 'bottom':
            return getShort(this.axes.y.func.scale()(d.safeValue)) + 16
          case 'insideBeginning':
            return getShort(this.axes.y.func.scale()(d.safeValue)) - 12
        }
      }
    }

    datumValues.attr('x', d => getDatumValuesXPosition(d))
    datumValues.attr('y', d => getDatumValuesYPosition(d))
    datumValues.attr('transform', 'rotate(0)')
    datumValues.attr('text-anchor', this.config.horizontal ? 'start' : 'middle')
    datumValues.style('dominant-baseline', 'middle')
    datumValues.style('stroke', 'unset')
    datumValues.style('fill', 'currentColor')

    if (this.config.datumValuesPosition === 'bottom') {
      if (this.config.horizontal) {
        datumValues.attr('text-anchor', 'end')
      }
    }

    if (['center', 'insideBeginning', 'insideEnd'].includes(this.config.datumValuesPosition)) {
      /*
      if (!this.config.horizontal) {
        datumValues.attr(
          'transform',
          d => `rotate(-90, ${getDatumValuesXPosition(d)}, ${getDatumValuesYPosition(d)})`
        )
      }
      */
      datumValues.style('dominant-baseline', 'central')
      datumValues.style('paint-order', 'stroke')
      datumValues.style('stroke', 'white')
      datumValues.style('stroke-width', '2px')
      datumValues.style('stroke-linecap', 'butt')
      datumValues.style('stroke-linejoin', 'round')
      datumValues.style('fill', 'black')
    }

    if (this.config.datumValuesPosition === 'center') {
      datumValues.attr('text-anchor', 'middle')
    }

    if (this.config.datumValuesPosition === 'insideBeginning') {
      if (this.config.horizontal) {
        datumValues.attr('text-anchor', 'start')
      }
    }

    if (this.config.datumValuesPosition === 'insideEnd') {
      if (this.config.horizontal) {
        datumValues.attr('text-anchor', 'end')
      }
    }

    // this.itemsEnter.append('text').attr('text-anchor', 'middle')
    // this.items
    //   .merge(this.itemsEnter)
    //   .select('text')
    //   // .text(d => this.formatValue(d.value, 'y'))
    //   .text(d => this.valueWithUnit(d.value, 'y'))
    //   .attr('x', this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2)
    //   .attr('y', -8)
  }

  calcDatumValueOffsets() {
    //ALERTA, {x,y} corresponeden al typo de axis NO a la direccion del offset
    if (this.config.showDatumValues && this.config.datumValuesPosition === 'bottom') {
      let offset = 20
      if (this.config.horizontal) {
        this.root.selectAll('.datum-value').each(function (d) {
          offset = Math.max(offset, this.getBoundingClientRect().width + 10)
        })
      }
      return { x: offset, y: 0 }
    }
    return { x: 0, y: 0 }
  }

  getLegendData() {
    return [
      { id: 'initial value', colorType: 'initial value' },
      { id: 'positive', colorType: 'positive' },
      { id: 'negative', colorType: 'negative' },
      { id: 'total', colorType: 'total' },
    ]
  }
}
